//    ____ _____ ___  ____
//   / ___|_   _/ _ \|  _ \
//   \___ \ | || | | | |_) |
//    ___) || || |_| |  __/
//   |____/ |_| \___/|_|
//
//  This file is deprecated.
//  Going forward please put all applicable api calls
//  in a respective xxxxx.api.js file located in 'Shared/api/xxxx.api.js'
//  example: Feedbacks.api.js, Goals.api.js, etc
//

import instance from './instance';

import { addObjectToFormData } from 'Shared/helpers';
import queryString from 'query-string';
import { trackInvitedTeammate } from 'Shared/tracking/tracking';

export const getWorkspaces = (input, params) => instance.get(`/api/v0/workspaces?q=${input}`, { params });

export const createAIFeedbackSuggestions = ({ receiverRole, scenario }) => {
  return instance(`/api/v0/feedbacks/create_ai_feedback_suggestions`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: { receiverRole, scenario },
  });
};

export const getSalesforceReferenceFieldOptions = async ({ recommendation_id, record_type, field_name }) =>
  instance(`/api/v0/recommendations/${recommendation_id}/salesforce_reference_field_options`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: { record_type, field_name },
  });

export const getWorkspace = ({ workspaceId, token, appId }) =>
  instance(`/api/v0/workspaces/${workspaceId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { appId },
  });

export const getTimelineGroupsForWorkspace = ({ workspaceId, groupBy }) =>
  instance.get(`/api/v0/workspaces/${workspaceId}/timeline_groups?group_by=${groupBy}`);

export const inviteToWorkspace = ({
  id,
  emails: inviteeEmails,
  personalMessage,
  workspaceName,
  setFullName,
  inviteMethod = '',
}) => {
  trackInvitedTeammate(inviteeEmails.length, inviteMethod);

  return instance(`/api/v0/workspaces/${id}/invite`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      inviteeEmails,
      personalMessage,
      workspaceName,
      setFullName,
    }),
  });
};

export const resendInvite = ({ workspaceId, userId }) =>
  instance(`/api/v0/workspaces/${workspaceId}/resend_invite`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      userId,
    }),
  });

export const removeFromWorkspace = ({ id, userId }) =>
  instance(`/api/v0/workspaces/${id}/remove`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      userId,
    }),
  });

export const updateWorkspace = (id, params) =>
  instance(`/api/v0/workspaces/${id}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: { workspace: params },
  });

export const archiveWorkspace = id =>
  instance(`/api/v0/workspaces/${id}/archive`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

export const starWorkspace = ({ workspaceId }) =>
  instance(`/api/v0/workspaces/${workspaceId}/star`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

export const unstarWorkspace = ({ workspaceId }) =>
  instance(`/api/v0/workspaces/${workspaceId}/unstar`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

export const deleteRecurrenceInWorkspace = ({ workspaceId }) =>
  instance.delete(`/api/v0/workspaces/${workspaceId}/destroy_recurrence`);

export const setRecurrenceInWorkspace = ({ workspaceId, recurrence }) =>
  instance.put(`/api/v0/workspaces/${workspaceId}/set_recurrence`, {
    recurrence,
  });

export const setCalendarMeetingInWorkspace = ({ calendarMeetingId, workspaceId, page }) =>
  instance.put(`/api/v0/workspaces/${workspaceId}/set_calendar_meeting`, {
    calendarMeetingId,
    page,
  });

export const setRecurringMeetingInWorkspace = ({ recurringMeetingId, workspaceId, page }) =>
  instance.put(`/api/v0/workspaces/${workspaceId}/set_recurring_meeting`, {
    recurringMeetingId,
    page,
  });

export const updatePresenceData = ({ workspaceId, workspaceItemUuid, active = true }) =>
  instance.put(`/api/v0/workspaces/${workspaceId}/update_presence_data`, {
    workspaceItemUuid,
    active,
  });

export const makeRequest = ({ endpoint, method, body }) =>
  instance(endpoint, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(body),
  });

export const getManagerAssistantSettings = () => instance.get('/api/v0/manager_assistant_settings');

export const updateManagerAssistantSetting = (id, params) =>
  instance(`/api/v0/manager_assistant_settings/${id}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(params),
  });

export const updatePulse = ({ user, showPulsePrompt, pulseMood }) =>
  instance(`/api/v0/users/${user.id}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: { show_pulse_prompt: showPulsePrompt, pulse_mood: pulseMood },
  });

export const getOrganizations = userID => instance.get(`/api/v0/admin/users/${userID}/organizations`);

export const toggleFeatureByAdmin = ({ userID, body }) =>
  instance(`/api/v0/admin/users/${userID}/toggle_feature`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(body),
  });

export const updateSalesforceUserLinks = links =>
  instance('/api/v0/recommendation_settings/update_salesforce_user_links', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ links }),
  });

export const updateSalesforceUserTags = ({ tags, userId }) =>
  instance('/api/v0/recommendation_settings/update_salesforce_user_tags', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ tags, userId }),
  });

export const updateRecommendationNotificationSettings = settings_updates =>
  instance('/api/v0/recommendation_settings/update_recommendation_notification_settings', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ settings_updates }),
  });

export const getRuleBuilderButtonOptions = ({ object }) =>
  instance.get(`/api/v0/recommendation_settings/buttons?object=${object}`);

export const getRuleBuilderFields = ({ object }) =>
  instance.get(`/api/v0/recommendation_settings/fields?object=${object}`);

export const getSalesforceUsers = () => instance.get('/api/v0/recommendation_settings/salesforce_users');

export const getRecommendationSettings = () => instance.get('/api/v0/recommendation_settings/recommendation_settings');

export const getRecommendationNotificationSettings = () =>
  instance.get('/api/v0/recommendation_settings/recommendation_notification_settings');

export const getCustomRecommendationSetting = recommendationSettingId =>
  instance.get(`/api/v0/recommendation_settings/${recommendationSettingId}`);

export const createCustomRecommendationSetting = recommendationSetting =>
  instance('/api/v0/recommendation_settings', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ recommendation_setting: recommendationSetting }),
  });

export const updateCustomRecommendationSetting = recommendationSetting =>
  instance(`/api/v0/recommendation_settings/${recommendationSetting.id}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ recommendation_setting: recommendationSetting }),
  });

export const updateRecommendationSettings = settings_updates =>
  instance('/api/v0/recommendation_settings/update_recommendation_settings', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ settings_updates }),
  });

export const toggleRecommendation = ({ recommendationKlassName }) =>
  instance('/api/v0/recommendation_settings/toggle_recommendation', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ recommendationKlassName }),
  });

export const getRecommendationPreviews = ({ recommendation_klass_name, request_id, settings }) =>
  instance('/api/v0/recommendation_settings/recommendation_previews', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: { recommendation_klass_name, request_id, settings },
  });

export const getRecommendationAnalytics = ({ userId, tags }) => {
  return instance('/api/v0/recommendation_analytics/main_dashboard', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: { userId, tags },
  });
};

export const getFilteredRecommendations = filter =>
  instance('/api/v0/recommendation_analytics/recommendations', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: filter,
  });

export const getAccounts = ({ globalIds, timerange, organization_id }) =>
  instance(`/api/v0/accounts?ids=${globalIds}&timerange=${timerange}&organization_id=${organization_id || ''}`, {
    method: 'GET',
  });

export const getRecommendationChart = ({ chartCode, timeFilters, userId, tags }) =>
  instance(`/api/v0/recommendation_charts/${chartCode}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: { ...timeFilters, userId, tags },
  });

export const readNotifications = () => instance.put('/api/v0/notifications/read_all');

export function readNotification(id) {
  return instance.put(`/api/v0/notifications/${id}/read_one`);
}

export function dismissNotification(id) {
  return instance.put(`/api/v0/notifications/dismiss/${id}`);
}

export const getNotifications = () => instance.get('/api/v0/notifications');

export const getWorkspaceNotificationCards = () => instance.get('/api/v0/workspace_notification_cards');

export const getShareOnChatStatus = () => instance.get('/api/v0/users/share_on_chat_status');

export const updateWorkspaceNotificationCard = (id, params) =>
  instance(`/api/v0/workspace_notification_cards/${id}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(params),
  });

export const getNotificationDestinations = () => instance.get('/api/v0/notifications/notification_destinations');
export const enableNotificationDestination = data => instance.post('/api/v0/notifications/enable_notification', data);
export const disableNotificationDestination = data => instance.post('/api/v0/notifications/disable_notification', data);

export const updateNotificationDestinationSettings = ({ notificationDestinationID, settings }) =>
  instance('/api/v0/users/update_notification_destination_settings', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      notification_destination_id: notificationDestinationID,
      settings,
    }),
  });

export const toggleNotification = ({ notificationDestinationID }) =>
  instance('/api/v0/users/toggle_notification', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      notification_destination_id: notificationDestinationID,
    }),
  });

export const disconnectOrganizationNotificationDestination = ({ notificationDestinationID }) =>
  instance('/api/v0/users/disconnect_organization_notification_destination', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      notification_destination_id: notificationDestinationID,
    }),
  });

export const disconnectNotification = ({ notificationDestinationID }) =>
  instance('/api/v0/users/disconnect_notification', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      notification_destination_id: notificationDestinationID,
    }),
  });

export const getSyncStatus = () => instance.get('/api/v0/users/sync_status');

export const getRecurringMeetings = (queryParams = {}) =>
  instance.get(
    queryString.stringifyUrl({
      url: '/api/v0/users/recurring_meetings',
      query: queryParams,
    })
  );

export const updateProfile = user => {
  const data = new FormData();
  addObjectToFormData(data, user, 'user');
  return instance.putForm(`/api/v0/users/${user.id}`, data);
};

export const createZoomClientEvent = ({ workspace_id, event_type, data }) => {
  return instance(`/api/v0/users/create_zoom_client_event`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: { workspace_id, event_type, data },
  });
};

export const resyncCalendar = () => {
  return instance(`/api/v0/users/resync_calendar`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};

export const getSeries = ({ metrics, timeFilters, jwt_token }) =>
  instance('/api/v0/time_series', {
    method: 'GET',
    params: {
      metrics: JSON.stringify(metrics),
      timefilters: JSON.stringify(timeFilters),
    },
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${jwt_token}`,
      'Content-Type': 'application/json',
    },
  });

export const getDocument = ({ url }) =>
  instance('/api/v0/smart_links/details', {
    method: 'GET',
    params: {
      url,
    },
  });

export const disonnectdataSource = id =>
  instance(`/api/v0/organization_data_sources/${id}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

export const duplicateTodo = params =>
  instance('/api/v0/workspaces/duplicate_workspace_items', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: params,
  });

export const addWorkspaceItemToGoal = params =>
  instance(`/api/v0/meeting_items/${params.itemUuid}/add_to_goal`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: params,
  });

export const createAsanaTaskFromWorkspaceItem = params =>
  instance(`/api/v0/meeting_items/${params.itemUuid}/create_asana_task`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: params,
  });

export const disconnectAsanaTaskFromWorkspaceItem = params =>
  instance(`/api/v0/meeting_items/${params.uuid}/disconnect_asana_task`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: params,
  });

export const updateOnboarding = ({ step }) => instance.get(`/api/v0/users/update_onboarding?step=${step}`);

export const resetWorkspaceNotifications = workspaceId =>
  instance.put(`/api/v0/workspaces/${workspaceId}/reset_notifications`);

export const bulkCreateWorkspaces = data => {
  // NOTE: We need this event to send to Facebook Pixel so we can
  // build Look-Alike Audiences.

  const invitee_emails = data.workspacesParams
    .map(workspaceParams => workspaceParams.inviteeEmails.filter(invitee => invitee != null))
    .flat();
  const from_calendar = data.workspacesParams.every(
    workspace => workspace.recurringMeetingId != null || workspace.inviteeEmailsFromCalendar
  );
  if (invitee_emails.length > 0) {
    trackInvitedTeammate(invitee_emails.length, data.inviteMethod, from_calendar);
  }
  return instance('/api/v0/workspaces/bulk_create_workspaces', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    data,
  });
};

export const requestAssistantDemoClick = ({ assistantType }) =>
  instance('/api/v0/users/request_assistant_demo_click', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    data: { assistant_type: assistantType },
  });

export const requestAssistantAccessClick = ({ assistantType }) =>
  instance('/api/v0/users/request_assistant_access_click', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    data: { assistant_type: assistantType },
  });

export const upsertRecurringWorkspaceItem = ({ workspaceItemUuid, ...data }) =>
  instance(`/api/v0/meeting_items/${workspaceItemUuid}/upsert_recurrence`, {
    method: 'PUT',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    data,
  });

export const deleteRecurringWorkspaceItem = ({ workspaceItemUuid, client_sync_token }) =>
  instance(`/api/v0/meeting_items/${workspaceItemUuid}/destroy_recurrence`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    data: {
      client_sync_token,
    },
  });

export function search(data) {
  const query = queryString.stringify(data, { arrayFormat: 'bracket' });
  return instance(`/api/v0/search?${query}`, {
    method: 'GET',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    data,
  });
}
